<template>
  <g
    id="Rear_Wheel"
    v-on:click="changeSeverity('rightRearWheel')"
    :class="severityClass"
  >
    <g>
      <g>
        <g>
          <rect
            class="cls-266"
            x="266.68"
            y="504.23"
            width=".3"
            height="21.23"
            transform="translate(321.95 -62.41) rotate(32.85)"
          />
          <rect
            class="cls-717"
            x="260.61"
            y="522.91"
            width=".5"
            height="2.36"
            transform="translate(326 -57.7) rotate(32.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="269.65"
            y="505.01"
            width=".3"
            height="21.23"
            transform="translate(231.55 -65.06) rotate(23.85)"
          />
          <rect
            class="cls-717"
            x="265.1"
            y="524.5"
            width=".5"
            height="2.36"
            transform="translate(235.19 -62.4) rotate(23.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="278.75"
            y="504.48"
            width=".3"
            height="21.23"
            transform="translate(-27.88 16.1) rotate(-3.15)"
          />
          <rect
            class="cls-717"
            x="279.25"
            y="524.9"
            width=".5"
            height="2.36"
            transform="translate(-28.51 16.17) rotate(-3.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="281.61"
            y="503.37"
            width=".3"
            height="21.23"
            transform="translate(-101.89 70.84) rotate(-12.15)"
          />
          <rect
            class="cls-717"
            x="283.82"
            y="523.56"
            width=".5"
            height="2.36"
            transform="translate(-104.07 71.54) rotate(-12.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="288.67"
            y="497.59"
            width=".3"
            height="21.23"
            transform="translate(-256.03 296.47) rotate(-39.15)"
          />
          <rect
            class="cls-717"
            x="295.51"
            y="515.55"
            width=".5"
            height="2.36"
            transform="translate(-259.84 302.74) rotate(-39.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="290.32"
            y="495.01"
            width=".3"
            height="21.23"
            transform="translate(-279.97 384.69) rotate(-48.15)"
          />
          <rect
            class="cls-717"
            x="298.41"
            y="511.78"
            width=".5"
            height="2.36"
            transform="translate(-282.71 393.23) rotate(-48.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="292.63"
            y="486.18"
            width=".3"
            height="21.23"
            transform="translate(-262.46 652.48) rotate(-75.15)"
          />
          <rect
            class="cls-717"
            x="303.16"
            y="498.44"
            width=".5"
            height="2.36"
            transform="translate(-257.28 664.86) rotate(-75.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="292.46"
            y="483.12"
            width=".3"
            height="21.23"
            transform="translate(-228.39 734.49) rotate(-84.15)"
          />
          <rect
            class="cls-717"
            x="303.29"
            y="493.68"
            width=".5"
            height="2.36"
            transform="translate(-219.68 746.38) rotate(-84.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="289.14"
            y="474.63"
            width=".3"
            height="21.23"
            transform="translate(-58.92 930.1) rotate(-111.15)"
          />
          <rect
            class="cls-717"
            x="299.29"
            y="480.1"
            width=".5"
            height="2.36"
            transform="translate(-41.24 934.29) rotate(-111.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="287.2"
            y="472.26"
            width=".3"
            height="21.23"
            transform="translate(14.09 973.85) rotate(-120.15)"
          />
          <rect
            class="cls-717"
            x="296.61"
            y="476.17"
            width=".5"
            height="2.36"
            transform="translate(33.21 973.81) rotate(-120.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="279.52"
            y="467.33"
            width=".3"
            height="21.23"
            transform="translate(255.37 1031.17) rotate(-147.15)"
          />
          <rect
            class="cls-717"
            x="285.38"
            y="467.53"
            width=".5"
            height="2.36"
            transform="translate(271.35 1017.4) rotate(-147.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="276.56"
            y="466.55"
            width=".3"
            height="21.23"
            transform="translate(336.82 1025.47) rotate(-156.15)"
          />
          <rect
            class="cls-717"
            x="280.9"
            y="465.93"
            width=".5"
            height="2.36"
            transform="translate(349.42 1008.01) rotate(-156.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="267.45"
            y="467.08"
            width=".3"
            height="21.23"
            transform="translate(561.03 939.97) rotate(176.85)"
          />
          <rect
            class="cls-717"
            x="266.74"
            y="465.54"
            width=".5"
            height="2.36"
            transform="translate(559.22 918.06) rotate(176.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="264.59"
            y="468.19"
            width=".3"
            height="21.23"
            transform="translate(624.36 891.14) rotate(167.85)"
          />
          <rect
            class="cls-717"
            x="262.18"
            y="466.88"
            width=".5"
            height="2.36"
            transform="translate(617.48 870.41) rotate(167.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="257.54"
            y="473.97"
            width=".3"
            height="21.23"
            transform="translate(763.45 697.73) rotate(140.85)"
          />
          <rect
            class="cls-717"
            x="250.49"
            y="474.88"
            width=".5"
            height="2.36"
            transform="translate(745.75 686.94) rotate(140.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="255.88"
            y="476.55"
            width=".3"
            height="21.23"
            transform="translate(789.74 621.48) rotate(131.85)"
          />
          <rect
            class="cls-717"
            x="247.59"
            y="478.65"
            width=".5"
            height="2.36"
            transform="translate(770.61 615.35) rotate(131.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="253.57"
            y="485.38"
            width=".3"
            height="21.23"
            transform="translate(798.17 377.87) rotate(104.85)"
          />
          <rect
            class="cls-717"
            x="242.84"
            y="492"
            width=".5"
            height="2.36"
            transform="translate(782.09 384.59) rotate(104.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="253.75"
            y="488.44"
            width=".3"
            height="21.23"
            transform="translate(776.21 297.29) rotate(95.84)"
          />
          <rect
            class="cls-717"
            x="242.7"
            y="496.75"
            width=".5"
            height="2.36"
            transform="translate(763.06 307) rotate(95.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="257.06"
            y="496.94"
            width=".3"
            height="21.23"
            transform="translate(637.77 84.54) rotate(68.85)"
          />
          <rect
            class="cls-717"
            x="246.7"
            y="510.34"
            width=".5"
            height="2.36"
            transform="translate(634.91 96.63) rotate(68.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="259.01"
            y="499.31"
            width=".3"
            height="21.23"
            transform="translate(569.92 29.71) rotate(59.85)"
          />
          <rect
            class="cls-717"
            x="249.39"
            y="514.27"
            width=".5"
            height="2.36"
            transform="translate(569.97 40.69) rotate(59.85)"
          />
        </g>
      </g>
      <g>
        <g>
          <rect
            class="cls-266"
            x="254.5"
            y="479.8"
            width=".3"
            height="21.23"
            transform="translate(-252.92 708.89) rotate(-85.85)"
          />
          <rect
            class="cls-717"
            x="243.43"
            y="488.44"
            width=".5"
            height="2.36"
            transform="translate(-262.3 697.22) rotate(-85.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="255.67"
            y="476.97"
            width=".3"
            height="21.23"
            transform="translate(-277.18 625.76) rotate(-76.85)"
          />
          <rect
            class="cls-717"
            x="244.85"
            y="483.9"
            width=".5"
            height="2.36"
            transform="translate(-283.02 613.4) rotate(-76.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="261.57"
            y="470.01"
            width=".3"
            height="21.23"
            transform="translate(-274.42 370.81) rotate(-49.85)"
          />
          <rect
            class="cls-717"
            x="253.06"
            y="472.36"
            width=".5"
            height="2.36"
            transform="translate(-271.97 361.82) rotate(-49.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="264.18"
            y="468.4"
            width=".3"
            height="21.23"
            transform="translate(-248.94 289.58) rotate(-40.85)"
          />
          <rect
            class="cls-717"
            x="256.88"
            y="469.52"
            width=".5"
            height="2.36"
            transform="translate(-245.24 282.82) rotate(-40.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="273.04"
            y="466.24"
            width=".3"
            height="21.23"
            transform="translate(-106.19 79.24) rotate(-13.85)"
          />
          <rect
            class="cls-717"
            x="270.3"
            y="465"
            width=".5"
            height="2.36"
            transform="translate(-103.73 78.32) rotate(-13.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="276.1"
            y="466.48"
            width=".3"
            height="21.23"
            transform="translate(-39.31 25.04) rotate(-4.85)"
          />
          <rect
            class="cls-717"
            x="275.06"
            y="464.95"
            width=".5"
            height="2.36"
            transform="translate(-38.42 24.94) rotate(-4.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="284.53"
            y="469.94"
            width=".3"
            height="21.23"
            transform="translate(202.24 -71.88) rotate(22.15)"
          />
          <rect
            class="cls-717"
            x="288.58"
            y="469.19"
            width=".5"
            height="2.36"
            transform="translate(198.69 -74.19) rotate(22.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="286.87"
            y="471.92"
            width=".3"
            height="21.23"
            transform="translate(290.99 -78.9) rotate(31.15)"
          />
          <rect
            class="cls-717"
            x="292.46"
            y="471.95"
            width=".5"
            height="2.36"
            transform="translate(286.95 -83.2) rotate(31.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="291.66"
            y="479.68"
            width=".3"
            height="21.23"
            transform="translate(554.32 -16.29) rotate(58.15)"
          />
          <rect
            class="cls-717"
            x="300.9"
            y="483.32"
            width=".5"
            height="2.36"
            transform="translate(553.8 -26.97) rotate(58.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="292.39"
            y="482.66"
            width=".3"
            height="21.23"
            transform="translate(633.51 32.16) rotate(67.15)"
          />
          <rect
            class="cls-717"
            x="302.42"
            y="487.83"
            width=".5"
            height="2.36"
            transform="translate(635.76 20.19) rotate(67.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="291.7"
            y="491.76"
            width=".3"
            height="21.23"
            transform="translate(814.03 247.66) rotate(94.15)"
          />
          <rect
            class="cls-717"
            x="302.57"
            y="501.99"
            width=".5"
            height="2.36"
            transform="translate(826.59 237.57) rotate(94.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="290.54"
            y="494.59"
            width=".3"
            height="21.23"
            transform="translate(848.78 337.09) rotate(103.15)"
          />
          <rect
            class="cls-717"
            x="301.14"
            y="506.53"
            width=".5"
            height="2.36"
            transform="translate(864.37 329.75) rotate(103.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="284.64"
            y="501.55"
            width=".3"
            height="21.23"
            transform="translate(859.88 624.74) rotate(130.15)"
          />
          <rect
            class="cls-717"
            x="292.94"
            y="518.08"
            width=".5"
            height="2.36"
            transform="translate(879.13 629.98) rotate(130.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="282.03"
            y="503.16"
            width=".3"
            height="21.23"
            transform="translate(831.67 717.83) rotate(139.15)"
          />
          <rect
            class="cls-717"
            x="289.12"
            y="520.92"
            width=".5"
            height="2.36"
            transform="translate(849.74 727.76) rotate(139.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="273.16"
            y="505.32"
            width=".3"
            height="21.23"
            transform="translate(662.22 951.41) rotate(166.15)"
          />
          <rect
            class="cls-717"
            x="275.69"
            y="525.43"
            width=".5"
            height="2.36"
            transform="translate(669.93 971.85) rotate(166.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="270.11"
            y="505.09"
            width=".3"
            height="21.23"
            transform="translate(583.11 1006.73) rotate(175.15)"
          />
          <rect
            class="cls-717"
            x="270.93"
            y="525.48"
            width=".5"
            height="2.36"
            transform="translate(585.92 1028.51) rotate(175.15)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="261.67"
            y="501.62"
            width=".3"
            height="21.23"
            transform="translate(311.16 1085.39) rotate(-157.85)"
          />
          <rect
            class="cls-717"
            x="257.42"
            y="521.25"
            width=".5"
            height="2.36"
            transform="translate(299.33 1103.45) rotate(-157.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="259.33"
            y="499.64"
            width=".3"
            height="21.23"
            transform="translate(217.6 1081.16) rotate(-148.85)"
          />
          <rect
            class="cls-717"
            x="253.54"
            y="518.49"
            width=".5"
            height="2.36"
            transform="translate(202.17 1095.69) rotate(-148.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="254.54"
            y="491.88"
            width=".3"
            height="21.23"
            transform="translate(-37.76 983.99) rotate(-121.85)"
          />
          <rect
            class="cls-717"
            x="245.1"
            y="507.12"
            width=".5"
            height="2.36"
            transform="translate(-56.95 984.93) rotate(-121.85)"
          />
        </g>
        <g>
          <rect
            class="cls-266"
            x="253.82"
            y="488.9"
            width=".3"
            height="21.23"
            transform="translate(-107.74 927.51) rotate(-112.85)"
          />
          <rect
            class="cls-717"
            x="243.58"
            y="502.61"
            width=".5"
            height="2.36"
            transform="translate(-125.74 924.11) rotate(-112.85)"
          />
        </g>
      </g>
    </g>
    <g>
      <g>
        <path
          class="cls-944"
          d="M316.05,492.04h0s0-.04,0-.06c-.02-.18-.04-.36-.06-.54,0-.06-.01-.12-.02-.18,0-.07-.01-.14-.03-.2,0,0,0,0,0,0-.91-7.35-3.65-14.12-7.79-19.84-.15-.21-.31-.42-.47-.63-.04-.06-.08-.11-.12-.16-1.31-1.74-2.75-3.37-4.31-4.89-.19-.18-.37-.36-.57-.54t0,0s-.1-.09-.14-.13c-1.59-1.48-3.3-2.84-5.1-4.06-.21-.14-.43-.29-.65-.43-.06-.04-.11-.07-.17-.11h0c-2.41-1.57-4.99-2.9-7.7-3.95-3.92-1.53-8.12-2.51-12.5-2.83-.26-.02-.52-.04-.78-.05-.07,0-.13,0-.2-.01-.72-.04-1.44-.05-2.17-.05-1.47,0-2.92,.07-4.35,.22-.26,.03-.52,.06-.78,.09-.06,0-.13,.01-.2,.02h0c-3.46,.42-6.79,1.26-9.94,2.46-1.77,.67-3.48,1.45-5.13,2.34-.47,.25-.93,.51-1.4,.79-.35,.2-.69,.41-1.04,.63-.79,.5-1.57,1.02-2.33,1.57,0,0,0,0,0,0-.21,.15-.41,.3-.62,.45,0,0,0,0,0,0-.03,.02-.05,.04-.08,.06-.03,.02-.05,.04-.08,.06,0,0,0,0,0,0-.28,.2-.55,.41-.82,.64-.39,.31-.78,.62-1.15,.95-1.02,.86-1.99,1.78-2.92,2.73h0c-.18,.18-.35,.37-.53,.55h0s0,0,0,0c-.03,.02-.04,.04-.07,.07-.02,.02-.04,.05-.07,.07t0,0c-1.48,1.59-2.84,3.29-4.06,5.09-.15,.21-.29,.43-.43,.65h0c-.04,.06-.07,.11-.11,.17,0,0,0,0,0,0-3.83,5.9-6.24,12.79-6.78,20.2h0c-.02,.26-.04,.52-.05,.78,0,.07,0,.14-.01,.2h0c-.04,.72-.06,1.44-.06,2.17,0,23.76,19.26,43.02,43.02,43.02s43.02-19.26,43.02-43.02c0-1.47-.08-2.92-.23-4.35Zm-63.19-19.74c.3-.25,.6-.5,.91-.74,.43-.34,.86-.67,1.31-.98,.3-.21,.6-.42,.9-.61,.28-.18,.56-.37,.85-.54,.3-.18,.6-.36,.91-.53,1.56-.89,3.2-1.64,4.91-2.25,.32-.11,.64-.23,.96-.33h0s.01,0,.02,0c1.03-.33,2.09-.61,3.17-.84,2.08-.43,4.24-.66,6.45-.66,.98,0,1.95,.04,2.91,.14h0c16.07,1.47,28.65,14.98,28.65,31.44,0,17.44-14.13,31.57-31.57,31.57s-31.57-14.13-31.57-31.57c0-9.66,4.34-18.31,11.18-24.1Z"
        />
        <path
          class="cls-717"
          d="M277.24,457.92c-1.31-.13-2.65-.2-3.99-.2-4.08,0-8.02,.63-11.71,1.81-.52,.16-1.04,.34-1.55,.52-.07,.03-.13,.05-.2,.08-1.77,.66-3.48,1.44-5.13,2.35-.07,.03-.13,.07-.19,.11h0c-.68,.38-1.35,.78-2,1.19-.32,.2-.63,.41-.94,.62-.65,.44-1.29,.9-1.91,1.38-.29,.22-.58,.45-.86,.68-8.66,7.09-14.19,17.87-14.19,29.94,0,21.36,17.32,38.68,38.68,38.68s38.68-17.32,38.68-38.68c0-20.01-15.2-36.48-34.69-38.48Zm-24.7,13.51c.29-.24,.58-.47,.87-.7,.39-.3,.78-.59,1.18-.88,.3-.21,.6-.41,.91-.61,.32-.21,.64-.41,.96-.61,.3-.18,.6-.35,.91-.52,1.56-.88,3.2-1.63,4.91-2.24,.32-.12,.64-.23,.96-.33,0,0,.01,0,.03-.01,1.16-.38,2.35-.69,3.57-.93,2.07-.41,4.22-.63,6.41-.63,.95,0,1.88,.04,2.81,.12,16.6,1.42,29.63,15.35,29.63,32.32,0,17.91-14.53,32.44-32.44,32.44s-32.44-14.53-32.44-32.44c0-10.04,4.56-19.02,11.73-24.97Z"
        />
        <path
          class="cls-566"
          d="M276.89,458.31c-1.2-.11-2.41-.17-3.64-.17-3.97,0-7.79,.6-11.39,1.72-.5,.16-.99,.32-1.48,.5-.14,.05-.28,.1-.42,.15-.02,0-.04,.01-.07,.03h-.01s-.06,.02-.09,.04h-.01c-1.66,.63-3.27,1.36-4.81,2.21h0s-.02,.01-.03,.02h-.01s-.06,.04-.08,.06c-.13,.07-.26,.14-.38,.21-.62,.35-1.24,.72-1.84,1.1-.31,.2-.62,.41-.93,.62-.61,.41-1.21,.85-1.79,1.3-.29,.22-.58,.45-.86,.68-8.57,7.01-14.03,17.67-14.03,29.61,0,21.13,17.13,38.25,38.25,38.25s38.25-17.13,38.25-38.25c0-19.9-15.2-36.25-34.61-38.08Zm-24.46,12.88c.28-.24,.57-.47,.87-.69,.38-.3,.76-.58,1.16-.86,.3-.21,.6-.41,.91-.61,.33-.22,.67-.43,1-.63,.3-.18,.6-.36,.91-.52,1.56-.88,3.2-1.63,4.91-2.25,.32-.11,.64-.23,.96-.33h0s.01-.01,.03-.01c1.19-.39,2.41-.71,3.66-.96,2.08-.41,4.23-.63,6.43-.63,.93,0,1.86,.04,2.78,.12,16.75,1.41,29.91,15.45,29.91,32.57,0,18.05-14.63,32.69-32.68,32.69s-32.69-14.64-32.69-32.69c0-10.14,4.62-19.2,11.87-25.2Z"
        />
      </g>
      <g>
        <path
          class="cls-204"
          d="M283,464.6c-.21-.07-.43-.13-.65-.19-.21-.07-.43-.12-.64-.18-1.86-.49-3.77-.82-5.74-.98-.9-.07-1.8-.11-2.71-.11-2.23,0-4.4,.22-6.5,.64-1.3,.25-2.58,.59-3.82,1h0c-2.4,.78-4.67,1.82-6.79,3.1-.37,.22-.73,.45-1.08,.68-.31,.2-.61,.4-.91,.62-.38,.27-.76,.54-1.12,.83-.29,.22-.58,.45-.86,.68-4.38,3.6-7.83,8.29-9.91,13.67-.08,.2-.16,.4-.23,.6-1.3,3.56-2.02,7.41-2.02,11.43,0,18.36,14.89,33.25,33.25,33.25s33.25-14.89,33.25-33.25c0-14.97-9.89-27.62-23.5-31.79Zm-9.75,63.13c-17.3,0-31.33-14.03-31.33-31.33,0-9.55,4.27-18.1,11.01-23.84,.3-.26,.61-.51,.92-.76,.44-.35,.89-.69,1.36-1.01,.3-.21,.6-.42,.91-.61,.27-.18,.54-.36,.82-.53,.3-.18,.6-.36,.91-.53,1.56-.88,3.19-1.64,4.91-2.24,.32-.12,.64-.23,.97-.33,0,0,.02,0,.02,0,.99-.32,2-.59,3.04-.8,2.09-.44,4.26-.67,6.48-.67,.99,0,1.98,.05,2.94,.14,15.93,1.48,28.39,14.88,28.39,31.19,0,17.3-14.02,31.33-31.33,31.33Z"
        />
        <path
          class="cls-717"
          d="M275.92,462.9c-.88-.07-1.77-.1-2.67-.1-2.25,0-4.45,.22-6.58,.64-1.3,.26-2.58,.59-3.82,1-.02,0-.05,0-.07,.02-.43,.14-.85,.28-1.28,.45h-.01l-.04,.02c-1.48,.55-2.91,1.21-4.28,1.96h-.02s-.01,.01-.01,.01c-.39,.22-.77,.44-1.16,.66-.38,.23-.75,.46-1.12,.71-.3,.19-.6,.4-.91,.61-.37,.26-.75,.54-1.11,.82-.29,.22-.58,.45-.86,.68-7.52,6.16-12.32,15.52-12.32,26,0,13.41,7.85,24.98,19.21,30.37,.2,.1,.4,.19,.61,.28,4.2,1.9,8.87,2.95,13.78,2.95,15.95,0,29.3-11.11,32.74-26.01,.05-.23,.1-.46,.15-.7,.05-.25,.1-.49,.14-.74,.37-1.99,.56-4.05,.56-6.15,0-17.66-13.62-32.13-30.93-33.49Zm-2.67,64.82c-17.3,0-31.33-14.03-31.33-31.33,0-9.55,4.27-18.1,11.01-23.84,.3-.26,.61-.51,.92-.76,.44-.35,.89-.69,1.36-1.01,.3-.21,.6-.42,.91-.61,.27-.18,.54-.36,.82-.53,.3-.18,.6-.36,.91-.53,1.56-.88,3.19-1.64,4.91-2.24,.32-.12,.64-.23,.97-.33,0,0,.02,0,.02,0,.99-.32,2-.59,3.04-.8,2.09-.44,4.26-.67,6.48-.67,.99,0,1.98,.05,2.94,.14,15.93,1.48,28.39,14.88,28.39,31.19,0,17.3-14.02,31.33-31.33,31.33Z"
        />
        <g class="cls-738">
          <path
            class="cls-253"
            d="M303.97,481.61c-.08-.17-.17-.34-.25-.51-5.28-10.32-15.67-17.59-27.83-18.48-.84-.06-1.67-.09-2.52-.09-2.32,0-4.57,.23-6.76,.67-1.28,.26-2.54,.59-3.77,.99-.05,.01-.1,.03-.15,.05-.16,.04-.31,.1-.46,.16-.14,.04-.28,.09-.41,.14-1.78,.64-3.5,1.43-5.13,2.35-.13,.07-.26,.14-.38,.22-.14,.08-.28,.16-.42,.24-.39,.23-.78,.48-1.16,.73-.3,.2-.61,.4-.9,.61-.38,.26-.75,.54-1.12,.82-.29,.22-.58,.45-.86,.68-7.67,6.25-12.57,15.77-12.57,26.44,0,5.5,1.3,10.69,3.61,15.29,0,.01,.01,.03,.02,.04,5.61,11.13,17.14,18.76,30.45,18.76,18.83,0,34.09-15.26,34.09-34.09,0-5.38-1.25-10.48-3.47-15.01Zm-45.11,45.15c-6.63-3.19-12.05-8.51-15.36-15.08-.1-.19-.19-.37-.28-.57-2.11-4.39-3.3-9.3-3.3-14.5,0-4.1,.74-8.03,2.09-11.66,.07-.2,.15-.4,.23-.6,2.11-5.35,5.56-10.03,9.94-13.62,.28-.23,.57-.46,.86-.68,.37-.28,.74-.56,1.12-.83,.3-.21,.6-.41,.91-.61,.35-.23,.71-.45,1.07-.67,2.12-1.27,4.39-2.32,6.78-3.1,0,0,0,0,.01,0,1.24-.41,2.51-.74,3.81-1,2.14-.43,4.34-.65,6.6-.65,.88,0,1.74,.03,2.6,.1,1.97,.15,3.88,.47,5.74,.95,.21,.06,.43,.11,.65,.17,.22,.06,.44,.12,.65,.19,8.75,2.63,16,8.74,20.11,16.73,.1,.18,.19,.38,.28,.57,2.18,4.44,3.41,9.44,3.41,14.73,0,2.02-.18,4-.52,5.92-.04,.25-.09,.5-.14,.74-.04,.24-.1,.47-.15,.7-3.35,14.93-16.68,26.08-32.62,26.08-4.96,0-9.66-1.08-13.89-3.02-.2-.09-.4-.18-.61-.28Z"
          />
        </g>
        <path
          class="cls-485"
          d="M303.97,481.61c-.08-.17-.17-.34-.25-.51-5.23-10.41-15.65-17.77-27.86-18.7-.86-.07-1.73-.1-2.61-.1-2.31,0-4.56,.23-6.74,.67-1.25,.25-2.47,.57-3.66,.95-.09,.03-.18,.06-.27,.09-.16,.05-.31,.1-.46,.16-.14,.04-.28,.09-.41,.14-1.78,.64-3.5,1.43-5.13,2.34-.13,.07-.26,.14-.38,.22-.14,.08-.28,.16-.42,.25-.4,.24-.8,.49-1.19,.75-.31,.2-.61,.4-.91,.61-.38,.26-.75,.54-1.12,.82-.29,.22-.58,.45-.86,.68-7.66,6.25-12.54,15.76-12.54,26.41,0,5.59,1.35,10.86,3.73,15.52,0,.01,.01,.03,.02,.04,5.65,11,17.12,18.53,30.34,18.53,18.83,0,34.09-15.26,34.09-34.09,0-5.3-1.21-10.31-3.36-14.78Zm-30.73,48.22c-12.96,0-24.19-7.37-29.74-18.15-.1-.19-.19-.37-.28-.57-2.18-4.44-3.41-9.44-3.41-14.73,0-10.42,4.77-19.74,12.25-25.87,.28-.23,.57-.46,.86-.68,.37-.28,.74-.56,1.12-.82,.3-.21,.6-.41,.91-.61,.36-.24,.73-.47,1.1-.7,2.12-1.28,4.4-2.32,6.8-3.11h0s.02,0,.03,0c1.25-.41,2.52-.75,3.83-1,2.11-.42,4.3-.64,6.54-.64,.91,0,1.8,.04,2.69,.11,11.9,.95,22.04,8.13,27.17,18.27,.1,.18,.19,.38,.28,.57,2.11,4.39,3.3,9.3,3.3,14.5,0,18.47-14.97,33.44-33.44,33.44Z"
        />
      </g>
    </g>
    <g>
      <circle
        class="cls-617"
        cx="273.25"
        cy="496.4"
        r="15.66"
        transform="translate(-289.49 562.74) rotate(-67.89)"
      />
      <circle
        class="cls-717"
        cx="273.25"
        cy="496.4"
        r="10.22"
        transform="translate(-106.74 76.06) rotate(-13.28)"
      />
      <circle class="cls-566" cx="273.25" cy="496.4" r="5.27" />
      <path
        class="cls-788"
        d="M283.75,487.35c0-.61-.5-1.11-1.11-1.11s-1.11,.5-1.11,1.11,.5,1.11,1.11,1.11,1.11-.5,1.11-1.11Z"
      />
      <path
        class="cls-728"
        d="M279.16,483.87c-.25-.56-.9-.81-1.46-.56-.56,.25-.81,.9-.56,1.46,.25,.56,.9,.81,1.46,.56,.56-.25,.81-.9,.56-1.46Z"
      />
      <path
        class="cls-729"
        d="M273.55,482.54c-.45-.41-1.15-.37-1.56,.08-.41,.45-.37,1.15,.08,1.56,.45,.41,1.15,.37,1.56-.08s.37-1.15-.08-1.56Z"
      />
      <path
        class="cls-727"
        d="M267.89,483.62c-.58-.19-1.21,.13-1.39,.71-.19,.58,.13,1.21,.71,1.39,.58,.19,1.21-.13,1.39-.71,.19-.58-.13-1.21-.71-1.39Z"
      />
      <path
        class="cls-724"
        d="M263.16,486.9c-.61,.06-1.05,.61-.98,1.22,.06,.61,.61,1.05,1.22,.98,.61-.06,1.05-.61,.98-1.22-.06-.61-.61-1.05-1.22-.98Z"
      />
      <path
        class="cls-722"
        d="M260.17,491.83c-.53,.31-.71,.98-.4,1.51,.31,.53,.98,.71,1.51,.4,.53-.31,.71-.98,.4-1.51-.31-.53-.98-.71-1.51-.4Z"
      />
      <path
        class="cls-723"
        d="M259.44,497.54c-.36,.49-.25,1.19,.24,1.55s1.19,.25,1.55-.24c.36-.49,.25-1.19-.24-1.55s-1.19-.25-1.55,.24Z"
      />
      <path
        class="cls-725"
        d="M261.1,503.06c-.13,.6,.25,1.19,.85,1.31,.6,.13,1.19-.25,1.31-.85s-.25-1.19-.85-1.31-1.19,.25-1.31,.85Z"
      />
      <path
        class="cls-726"
        d="M264.86,507.42c.13,.6,.71,.98,1.31,.85s.98-.71,.85-1.31-.71-.98-1.31-.85c-.6,.13-.98,.71-.85,1.31Z"
      />
      <path
        class="cls-823"
        d="M270.07,509.88c.36,.49,1.05,.6,1.55,.24,.49-.36,.6-1.05,.24-1.55-.36-.49-1.05-.6-1.55-.24-.49,.36-.6,1.05-.24,1.55Z"
      />
      <path
        class="cls-824"
        d="M275.83,510.01c.53,.31,1.21,.12,1.51-.4,.31-.53,.12-1.21-.4-1.51-.53-.31-1.21-.12-1.51,.4-.31,.53-.12,1.21,.4,1.51Z"
      />
      <path
        class="cls-821"
        d="M281.14,507.78c.61,.06,1.15-.38,1.22-.98s-.38-1.15-.98-1.22c-.61-.06-1.15,.38-1.22,.98-.06,.61,.38,1.15,.98,1.22Z"
      />
      <path
        class="cls-822"
        d="M285.09,503.59c.58-.19,.9-.81,.71-1.39-.19-.58-.81-.9-1.39-.71-.58,.19-.9,.81-.71,1.39,.19,.58,.81,.9,1.39,.71Z"
      />
      <path
        class="cls-818"
        d="M286.99,498.15c.45-.41,.49-1.11,.08-1.56-.41-.45-1.11-.49-1.56-.08-.45,.41-.49,1.11-.08,1.56,.41,.45,1.11,.49,1.56,.08Z"
      />
      <path
        class="cls-817"
        d="M286.52,492.41c.25-.56,0-1.21-.56-1.46-.56-.25-1.21,0-1.46,.56-.25,.56,0,1.21,.56,1.46,.56,.25,1.21,0,1.46-.56Z"
      />
      <g>
        <path
          class="cls-314"
          d="M283.42,487.35c0-.43-.35-.77-.77-.77s-.77,.35-.77,.77,.35,.77,.77,.77,.77-.35,.77-.77Z"
        />
        <path
          class="cls-314"
          d="M278.86,484c-.17-.39-.63-.57-1.02-.39-.39,.17-.57,.63-.39,1.02s.63,.57,1.02,.39c.39-.17,.57-.63,.39-1.02Z"
        />
        <path
          class="cls-314"
          d="M273.33,482.79c-.32-.29-.81-.26-1.09,.06-.29,.32-.26,.81,.06,1.09,.32,.29,.81,.26,1.09-.06,.29-.32,.26-.81-.06-1.09Z"
        />
        <path
          class="cls-314"
          d="M267.79,483.93c-.41-.13-.84,.09-.98,.5s.09,.84,.5,.98c.41,.13,.84-.09,.98-.5,.13-.41-.09-.84-.5-.98Z"
        />
        <path
          class="cls-314"
          d="M263.19,487.23c-.43,.04-.73,.43-.69,.85,.04,.43,.43,.73,.85,.69,.43-.04,.73-.43,.69-.85-.04-.43-.43-.73-.85-.69Z"
        />
        <path
          class="cls-314"
          d="M260.34,492.11c-.37,.21-.5,.69-.28,1.06,.21,.37,.69,.5,1.06,.28s.5-.69,.28-1.06c-.21-.37-.69-.5-1.06-.28Z"
        />
        <path
          class="cls-314"
          d="M259.71,497.74c-.25,.35-.17,.83,.17,1.08s.83,.17,1.08-.17,.17-.83-.17-1.08-.83-.17-1.08,.17Z"
        />
        <path
          class="cls-314"
          d="M261.43,503.13c-.09,.42,.18,.83,.6,.92,.42,.09,.83-.18,.92-.6,.09-.42-.18-.83-.6-.92s-.83,.18-.92,.6Z"
        />
        <path
          class="cls-314"
          d="M265.19,507.35c.09,.42,.5,.69,.92,.6s.69-.5,.6-.92-.5-.69-.92-.6c-.42,.09-.69,.5-.6,.92Z"
        />
        <circle
          class="cls-314"
          cx="270.97"
          cy="509.23"
          r=".77"
          transform="translate(-265.66 297.63) rotate(-40.46)"
        />
        <path
          class="cls-314"
          d="M276,509.72c.37,.21,.84,.09,1.06-.28s.09-.84-.28-1.06c-.37-.21-.84-.09-1.06,.28-.21,.37-.09,.84,.28,1.06Z"
        />
        <path
          class="cls-314"
          d="M281.18,507.45c.43,.04,.81-.26,.85-.69,.04-.43-.26-.81-.69-.85-.43-.04-.81,.26-.85,.69-.04,.43,.26,.81,.69,.85Z"
        />
        <path
          class="cls-314"
          d="M284.99,503.27c.41-.13,.63-.57,.5-.98-.13-.41-.57-.63-.98-.5-.41,.13-.63,.57-.5,.98,.13,.41,.57,.63,.98,.5Z"
        />
        <path
          class="cls-314"
          d="M286.77,497.9c.32-.29,.34-.78,.06-1.09s-.78-.34-1.09-.06c-.32,.29-.34,.78-.06,1.09s.78,.34,1.09,.06Z"
        />
        <path
          class="cls-314"
          d="M286.21,492.27c.17-.39,0-.85-.39-1.02-.39-.17-.85,0-1.02,.39-.17,.39,0,.85,.39,1.02,.39,.17,.85,0,1.02-.39Z"
        />
      </g>
    </g>
    <path
      class="cls-611"
      d="M296.94,497.23l-15.4,3.14-12.95,2.64c-.51,.1-.99-.28-.99-.81l-.03-11.27c0-.49,.42-.87,.9-.83l13.07,1.2,15.16,1.4c2.63,.24,2.83,4,.25,4.53Z"
    />
    <path
      class="cls-471"
      d="M296.94,497.23l-15.4,3.14v-9.06l15.16,1.4c2.63,.24,2.83,4,.25,4.53Z"
    />
    <path
      class="cls-526"
      d="M233.11,472.14l.8-1.99,60.83,23.4c.42,.16,.69,.56,.69,1h0c0,.76-.76,1.28-1.47,1.01l-60.85-23.43Z"
    />
    <path
      class="cls-533"
      d="M238.79,472.04c-.42,.6-.82,1.2-1.21,1.82l-4.47-1.72,.8-1.99,4.89,1.88Z"
    />
    <path
      class="cls-267"
      d="M241.78,452.13v12.71c-6,5.99-10.3,13.68-12.12,22.28h-11.43c-1.48,0-2.68-1.2-2.68-2.68v-28.5c0-2.11,1.71-3.82,3.82-3.82h22.41Z"
    />
    <path
      class="cls-315"
      d="M219.02,496.85c-.33,0-.65-.13-.88-.37-.23-.24-.36-.55-.35-.88,.21-14.65,6.07-28.39,16.5-38.69,10.45-10.31,24.28-15.99,38.96-15.99s28.71,5.75,39.17,16.2l.56,.56-7.91,3.35-3.64,1.54-.25-.21c-7.85-6.45-17.77-10-27.94-10-22.74,0-41.57,17.04-43.81,39.63-.07,.76-.55,1.43-1.24,1.75l-5.35,2.44c-.96,.44-1.97,.66-3.02,.66h-.81Z"
    />
    <g>
      <rect
        class="cls-435"
        x="271.63"
        y="492.17"
        width="4.71"
        height="4.6"
        rx=".38"
        ry=".38"
        transform="translate(189.46 -64.48) rotate(20.39)"
      />
      <path
        class="cls-981"
        d="M290.92,456.08l-.1,.28-.02,.04-.39,1.03-.12,.3v.03s-.39,1.02-.39,1.02h0s-.02,.04-.02,.04l-.13,.34-.26,.68-.11,.3-.02,.04-.38,1.02-.02,.05-.13,.34-.26,.68-.13,.34-.4,1.06-.13,.34-.26,.69-.13,.34-.39,1.06-.13,.34-.26,.68-.13,.34-.4,1.06-.13,.34-.26,.68-.12,.34-.4,1.07-.13,.34-.25,.68-.13,.34-.4,1.06-.13,.34-.26,.69-.13,.34-.4,1.06-.13,.34-.25,.68-.13,.34-.4,1.06-.13,.35-.26,.68-.13,.34-.4,1.06-.13,.34-.26,.68-.13,.34-.4,1.06-.12,.34-.26,.69-.13,.34-.45,1.2-.06,.18c-.03,.07-.11,.11-.18,.08l-4.33-1.61c-.07-.03-.11-.11-.09-.18l.07-.18,.06-.17,.13-.34,.26-.69,.13-.34,.4-1.06,.13-.34,.25-.68h0s.13-.35,.13-.35l.4-1.06,.13-.34,.26-.68,.13-.34,.4-1.06,.13-.34,.26-.69,.12-.34,.4-1.06,.13-.34,.26-.69,.13-.34,.4-1.06,.13-.34,.26-.68,.13-.34,.4-1.06,.13-.34,.25-.68,.13-.34,.4-1.06,.13-.34,.26-.68,.13-.34,.4-1.06,.12-.34,.26-.69,.13-.34,.4-1.06,.13-.34,.26-.68,.13-.34,.4-1.06,.13-.34,.26-.68,.13-.34,.39-1.06,.39-1.03,.13-.34,.4-1.06,.11-.29c.53,.17,1.05,.34,1.58,.52,1.01,.35,2.01,.75,3,1.18,0,0,.01,0,.02,.01Z"
      />
      <g>
        <path
          class="cls-105"
          d="M276.15,498.36c1.5-2.25,.09-5.23-2.65-5.46-1.22-.11-2.43,.49-3.11,1.51-1.5,2.25-.09,5.23,2.65,5.46,1.22,.1,2.43-.49,3.11-1.51Z"
        />
        <path
          class="cls-717"
          d="M275.96,498.19c1.33-2.04,.11-4.7-2.3-5.02-1.2-.16-2.41,.4-3.07,1.41-1.33,2.04-.11,4.7,2.3,5.02,1.2,.16,2.41-.4,3.07-1.41Z"
        />
        <path
          class="cls-707"
          d="M275.36,497.97c1.26-1.73,.14-4.1-2.03-4.2-.84-.04-1.65,.36-2.14,1.04-1.26,1.73-.13,4.1,2.03,4.2,.84,.04,1.65-.36,2.14-1.04Z"
        />
        <path
          class="cls-336"
          d="M275.25,497.85c1.13-1.58,.15-3.73-1.79-3.91-.83-.08-1.67,.31-2.16,.99-1.13,1.58-.15,3.73,1.79,3.91,.83,.08,1.67-.31,2.16-.99Z"
        />
        <path
          class="cls-22"
          d="M274.97,497.64c.97-1.36,.13-3.2-1.54-3.36-.71-.07-1.43,.26-1.85,.85-.97,1.36-.13,3.2,1.54,3.36,.71,.07,1.43-.26,1.85-.85Z"
        />
        <path
          class="cls-717"
          d="M272.24,497l-.14-.85c-.02-.13,.03-.27,.13-.35l.67-.55c.1-.09,.25-.11,.37-.06l.81,.3c.13,.05,.22,.16,.24,.29l.14,.85c.02,.13-.03,.27-.13,.35l-.67,.55c-.1,.09-.25,.11-.37,.06l-.81-.3c-.13-.05-.22-.16-.24-.29Z"
        />
        <path
          class="cls-254"
          d="M272.35,496.16l.88-.73s.09-.04,.14-.02l.95,.35-.03-.21-1.14-.42s-.1,0-.14,.02l-.88,.73s-.06,.08-.05,.13l.2,1.2,.2,.07-.17-1s.01-.1,.05-.13Z"
        />
      </g>
      <path
        class="cls-982"
        d="M273.62,484.57h4.93c.21,0,.38,.17,.38,.38v6.39c0,.96-.78,1.75-1.75,1.75h-2.19c-.96,0-1.75-.78-1.75-1.75v-6.39c0-.21,.17-.38,.38-.38Z"
        transform="translate(187.62 -65.56) rotate(20.39)"
      />
      <path
        class="cls-337"
        d="M272.17,491.21h0c-.12,.34,.05,.71,.38,.83l4.11,1.53c.34,.12,.71-.05,.83-.38h0c.03-.07,0-.15-.08-.18l-5.06-1.88c-.07-.03-.15,0-.18,.08Z"
      />
    </g>
    <g class="cls-738">
      <polygon
        class="cls-532"
        points="280.7 483.46 280.31 484.49 275.33 483.81 275.72 482.78 280.7 483.46"
      />
      <polygon
        class="cls-532"
        points="281.6 481.03 281.22 482.06 276.24 481.38 276.62 480.36 281.6 481.03"
      />
      <polygon
        class="cls-532"
        points="282.51 478.61 282.13 479.63 277.15 478.95 277.53 477.93 282.51 478.61"
      />
      <polygon
        class="cls-532"
        points="283.42 476.18 283.04 477.2 278.06 476.52 278.44 475.5 283.42 476.18"
      />
      <polygon
        class="cls-532"
        points="284.33 473.75 283.94 474.77 278.96 474.1 279.35 473.07 284.33 473.75"
      />
      <polygon
        class="cls-532"
        points="285.23 471.32 284.85 472.35 279.87 471.67 280.25 470.64 285.23 471.32"
      />
      <polygon
        class="cls-532"
        points="286.14 468.89 285.76 469.91 280.78 469.24 281.16 468.21 286.14 468.89"
      />
      <polygon
        class="cls-532"
        points="287.05 466.46 286.66 467.49 281.68 466.81 282.07 465.78 287.05 466.46"
      />
      <polygon
        class="cls-532"
        points="287.95 464.03 287.57 465.06 282.59 464.38 282.97 463.35 287.95 464.03"
      />
      <polygon
        class="cls-532"
        points="288.86 461.6 288.48 462.63 283.5 461.95 283.88 460.92 288.86 461.6"
      />
      <polygon
        class="cls-532"
        points="289.77 459.17 289.39 460.19 284.41 459.51 284.79 458.49 289.77 459.17"
      />
      <polygon
        class="cls-532"
        points="290.68 456.74 290.29 457.76 285.31 457.09 285.7 456.06 290.68 456.74"
      />
      <path
        class="cls-532"
        d="M287.91,454.89l-1.69-.23,.11-.29c.53,.17,1.05,.34,1.58,.52Z"
      />
    </g>
    <g>
      <path
        class="cls-532"
        d="M281.99,483.56c-.19,.46-.65,.72-1.14,.65l-.33-.05-5.38-.73s-.03,0-.04,0c-.03,0-.05-.01-.07-.02-.23-.08-.38-.32-.34-.57,.04-.29,.31-.49,.6-.46l.19,.03,5.41,.74,.1,.02-.08-.06,.39-1.06,.34,.26c.39,.3,.53,.81,.33,1.26Z"
      />
      <path
        class="cls-532"
        d="M282.89,481.13c-.19,.46-.65,.72-1.14,.65l-.33-.05-5.38-.73s-.03,0-.04,0c-.03,0-.05-.01-.07-.02-.23-.08-.38-.32-.34-.57,.04-.29,.31-.49,.6-.46l.19,.03,5.41,.74,.1,.02-.08-.06,.39-1.06,.34,.26c.39,.3,.53,.81,.33,1.26Z"
      />
      <path
        class="cls-532"
        d="M283.79,478.7c-.19,.46-.65,.72-1.14,.65l-.33-.05-5.38-.73s-.03,0-.04,0c-.03,0-.05-.01-.07-.02-.23-.08-.38-.32-.34-.57,.04-.29,.31-.49,.6-.46l.19,.03,5.41,.74,.1,.02-.08-.06,.39-1.06,.34,.26c.39,.3,.53,.81,.33,1.26Z"
      />
      <path
        class="cls-532"
        d="M284.69,476.27c-.19,.46-.65,.72-1.14,.65l-.33-.05-5.38-.73s-.03,0-.04,0c-.03,0-.05-.01-.07-.02-.23-.08-.38-.32-.34-.57,.04-.29,.31-.49,.6-.46l.19,.03,5.41,.74,.1,.02-.08-.06,.39-1.06,.34,.26c.39,.3,.53,.81,.33,1.26Z"
      />
      <path
        class="cls-532"
        d="M285.59,473.84c-.19,.46-.65,.72-1.14,.65l-.33-.05-5.38-.73s-.03,0-.04,0c-.03,0-.05-.01-.07-.02-.23-.08-.38-.32-.34-.57,.04-.29,.31-.49,.6-.46l.19,.03,5.41,.74,.1,.02-.08-.06,.39-1.06,.34,.26c.39,.3,.53,.81,.33,1.26Z"
      />
      <path
        class="cls-532"
        d="M286.49,471.41c-.19,.46-.65,.72-1.14,.65l-.33-.05-5.38-.73s-.03,0-.04,0c-.03,0-.05-.01-.07-.02-.23-.08-.38-.32-.34-.57,.04-.29,.31-.49,.6-.46l.19,.03,5.41,.74,.1,.02-.08-.06,.39-1.06,.34,.26c.39,.3,.53,.81,.33,1.26Z"
      />
      <path
        class="cls-532"
        d="M287.39,468.98c-.19,.46-.65,.72-1.14,.65l-.33-.05-5.38-.73s-.03,0-.04,0c-.03,0-.05-.01-.07-.02-.23-.08-.38-.32-.34-.57,.04-.29,.31-.49,.6-.46l.19,.03,5.41,.74,.1,.02-.08-.06,.39-1.06,.34,.26c.39,.3,.53,.81,.33,1.26Z"
      />
      <path
        class="cls-532"
        d="M288.28,466.55c-.19,.46-.65,.72-1.14,.65l-.33-.05-5.38-.73s-.03,0-.04,0c-.03,0-.05-.01-.07-.02-.23-.08-.38-.32-.34-.57,.04-.29,.31-.49,.6-.46l.19,.03,5.41,.74,.1,.02-.08-.06,.39-1.06,.34,.26c.39,.3,.53,.81,.33,1.26Z"
      />
      <path
        class="cls-532"
        d="M289.18,464.12c-.19,.46-.65,.72-1.14,.65l-.33-.05-5.38-.73s-.03,0-.04,0c-.03,0-.05-.01-.07-.02-.23-.08-.38-.32-.34-.57,.04-.29,.31-.49,.6-.46l.19,.03,5.41,.74,.1,.02-.08-.06,.39-1.06,.34,.26c.39,.3,.53,.81,.33,1.26Z"
      />
      <path
        class="cls-532"
        d="M290.08,461.69c-.19,.46-.65,.72-1.14,.65l-.33-.05-5.38-.73s-.03,0-.04,0c-.03,0-.05-.01-.07-.02-.23-.08-.38-.32-.34-.57,.04-.29,.31-.49,.6-.46l.19,.03,5.41,.74,.1,.02-.08-.06,.39-1.06,.34,.26c.39,.3,.53,.81,.33,1.26Z"
      />
      <path
        class="cls-532"
        d="M290.98,459.26c-.19,.46-.65,.72-1.14,.65l-.33-.05-5.38-.73s-.03,0-.04,0c-.03,0-.05-.01-.07-.02-.23-.08-.38-.32-.34-.57,.04-.29,.31-.49,.6-.46l.19,.03,5.41,.74,.1,.02-.08-.06,.39-1.06,.34,.26c.39,.3,.53,.81,.33,1.26Z"
      />
      <path
        class="cls-532"
        d="M291.95,456.54c-.01,.09-.04,.19-.07,.28-.19,.46-.65,.72-1.13,.65l-.32-.05h-.01l-4.97-.68-.41-.05s-.03,0-.04-.01c-.03,0-.05-.01-.07-.02-.23-.09-.38-.33-.34-.58,.04-.29,.3-.49,.6-.45l.19,.03,.45,.06,4.97,.68h.02l.08,.02-.06-.05h-.02s.1-.29,.1-.29c0,0,.01,0,.02,.01,.35,.14,.69,.3,1.03,.46Z"
      />
    </g>
    <path
      class="cls-611"
      d="M297.66,495.09c0-1.01-.82-1.83-1.83-1.83s-1.83,.82-1.83,1.83,.82,1.83,1.83,1.83,1.83-.82,1.83-1.83Z"
    />
    <circle class="cls-267" cx="295.82" cy="495.09" r="1.18" />
  </g>
</template>
<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
